<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>超时数据列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <el-select
          v-model="billType"
          placeholder="账单类型"
          @change="handleSearch"
        >
          <el-option label="所有账单类型" value></el-option>
          <el-option
            v-for="type in billTypes"
            :key="type.value"
            :label="type.label"
            :value="type.value"
          ></el-option>
        </el-select>
        <el-select v-model="status" placeholder="状态" @change="handleSearch">
          <el-option label="全部" value></el-option>
          <el-option
            v-for="type in statusType"
            :key="type.value"
            :label="type.label"
            :value="type.value"
          ></el-option>
        </el-select>
      </div>
      <bill-list @refresh="refreshList"></bill-list>
    </el-card>
  </div>
</template>

<script>
import './store';
import BillList from './components/BillList';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'Bill',
  data() {
    return {
      billType: '',
      status: '',
      statusType: [
        { value: 0, label: '未处理' },
        { value: 1, label: '处理中' },
        { value: 2, label: '待人工处理' },
        { value: 3, label: '已处理' },
        { value: 4, label: '处理失败' }
      ]
    };
  },
  computed: {
    ...mapState('overtime', ['pagination', 'billTypes'])
  },
  methods: {
    ...mapActions('overtime', ['getUserBillList', 'listBillType']),
    handleSearch() {
      this.refreshList({
        businessType: this.billType,
        status: this.status
      });
    },
    refreshList(data = {}) {
      this.getBill({
        businessType: this.billType,
        status: this.status,
        ...this.pagination,
        ...data
      });
    },
    getBill(data) {
      this.getUserBillList({
        ...this.pagination,
        ...data
      });
    }
  },
  created() {
    this.getBill();
    this.listBillType();
  },
  components: {
    BillList
  }
};
</script>

<style lang="less" scoped></style>
